var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { ref: "modal", staticClass: "modal fade" }, [
    _c(
      "div",
      { staticClass: "modal-dialog modal-xs", attrs: { role: "document" } },
      [
        _c("div", { staticClass: "modal-content" }, [
          _c("div", { staticClass: "modal-header" }, [
            _c("h5", { staticClass: "modal-title" }, [
              _vm._v(
                _vm._s(_vm.$t("kanban.massSelect.archive.confirmModal.title"))
              )
            ]),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "close",
                attrs: { type: "button" },
                on: {
                  click: function($event) {
                    $event.preventDefault()
                    return _vm.dismiss.apply(null, arguments)
                  }
                }
              },
              [_vm._v("×")]
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "modal-body" }, [
            _vm._v(
              "\n        " +
                _vm._s(
                  _vm.$t("kanban.massSelect.archive.confirmModal.message", {
                    cardCount: _vm.state.massSelectionCards.length
                  })
                ) +
                "\n      "
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "modal-footer" }, [
            _c(
              "button",
              { staticClass: "btn btn-secondary", on: { click: _vm.dismiss } },
              [_vm._v(_vm._s(_vm.$t("btnCancel")))]
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "btn btn-danger",
                attrs: { disabled: _vm.saving },
                on: { click: _vm.save }
              },
              [
                _vm.saving
                  ? _c("Spinner", { attrs: { small: true } })
                  : _vm._e(),
                _vm._v(
                  "\n          " +
                    _vm._s(
                      _vm.$t("kanban.massSelect.archive.confirmModal.archive")
                    ) +
                    "\n        "
                )
              ],
              1
            )
          ])
        ])
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }